module.exports = __webpack_public_path__ + "static/media/offline_bolt-24px.79c5b53c.svg";